(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tns-assist-cta"] && !Shopify.designMode) return;
  try {
    
  /* "Start a conversation" opens the native Shopify Inbox chat widget
     (<shopify-chat>, the "Chat" bubble bottom-right) instead of navigating
     to the contact page. If the widget hasn't loaded for any reason, the
     link falls back to its normal href (Shopify Inbox must be enabled in
     Settings → Customer accounts / Inbox for the widget to exist at all). */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-tns-open-chat]');
    if (!trigger) return;
    var chat = document.querySelector('shopify-chat');
    if (chat && typeof chat.show === 'function') {
      e.preventDefault();
      chat.show();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tns-benefits"] && !Shopify.designMode) return;
  try {
    
  /* Benefits accordion: only one item open at a time, and the side image
     swaps to match whichever benefit is open (each block can carry its own
     contextual lifestyle photo via data-image).
     2026-10-02: quoted the url() value here too — same unquoted-url bug as
     the server-rendered version above, so a value with special characters
     would have silently failed to apply on click as well. */
  (function(){
    document.querySelectorAll('.tns-benefits').forEach(function(section){
      var acc = section.querySelector('.tns-acc');
      var image = section.querySelector('.tns-benefits__image');
      if(!acc) return;
      var items = acc.querySelectorAll('.tns-acc__item');

      function setImage(item){
        var src = item.getAttribute('data-image');
        if(!image || !src) return;
        image.style.opacity = '0.4';
        window.setTimeout(function(){
          image.style.backgroundImage = "url('" + src + "')";
          image.style.opacity = '1';
        }, 150);
      }

      items.forEach(function(item){
        item.addEventListener('toggle', function(){
          if(!item.open) return;
          items.forEach(function(other){
            if(other !== item && other.open) other.open = false;
          });
          setImage(item);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tns-dosage-calculator"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function boot(root){
      if(!root || root.dataset.dcReady==='1') return;
      root.dataset.dcReady='1';

      var state={ format:'pen', dose:50 };

      function $(id){return root.querySelector('#'+id);}
      function fmt(n,d){return Number(n).toFixed(d);}

      var formatSeg=$('dc-format');
      if(formatSeg){
        formatSeg.addEventListener('click',function(e){
          var b=e.target.closest('button'); if(!b) return;
          formatSeg.querySelectorAll('button').forEach(function(x){x.classList.remove('is-on');});
          b.classList.add('is-on');
          state.format=b.dataset.v;
          render();
        });
      }

      var dose=$('dc-dose');
      dose.addEventListener('input',function(){state.dose=parseFloat(dose.value);render();});

      function drawBarrel(value, maxValue){
        var x0=36, w=328; // barrel inner
        var frac=Math.max(0,Math.min(1,value/maxValue));
        var fillW=w*frac;
        $('dc-fill').setAttribute('width', fmt(fillW,1));
        var edge=x0+fillW;
        $('dc-plunger').setAttribute('x', fmt(edge-6,1));
        root.querySelector('#dc-marker line').setAttribute('x1', fmt(edge,1));
        root.querySelector('#dc-marker line').setAttribute('x2', fmt(edge,1));
        var ticks='';
        var divisions=5;
        for(var i=0;i<=divisions;i++){
          var tv = maxValue*(i/divisions);
          var tx=x0 + w*(i/divisions);
          ticks += '<line x1="'+fmt(tx,1)+'" y1="46" x2="'+fmt(tx,1)+'" y2="60" stroke-width="1.5"/>';
          ticks += '<text x="'+fmt(tx,1)+'" y="112" font-size="11" text-anchor="middle" stroke="none">'+(maxValue<2? fmt(tv,2) : Math.round(tv))+'</text>';
        }
        $('dc-ticks').innerHTML=ticks;
      }

      // The pen's dial: as the dose rises the cap turns (ridges slide) and screws
      // out a little, and the window shows the number of units to dial.
      var PEN_MAX_UNITS = 60; // 100 mg of a 166.7 mg/ml cartridge = 0.60 ml
      function drawPen(units){
        var frac = Math.max(0, Math.min(1, units / PEN_MAX_UNITS));
        var knob = $('dc-knob');
        knob.setAttribute('transform', 'translate(' + fmt(394 + frac*14, 1) + ' 50)');
        var ridges = '';
        var spacing = 9, shift = (units * 1.8) % spacing;
        for (var x = -spacing; x < 52 + spacing; x += spacing) {
          var rx = x + shift;
          ridges += '<line x1="' + fmt(rx,1) + '" y1="-2" x2="' + fmt(rx,1) + '" y2="52"/>';
        }
        $('dc-ridges').innerHTML = ridges;
        var num = $('dc-pen-num');
        num.textContent = String(units);
        num.classList.remove('dc-pen-pop');
        void num.getBoundingClientRect();
        num.classList.add('dc-pen-pop');
        $('dc-pen-note').textContent = 'Turn the dial ' + units + ' clicks, until the window reads ' + units + '.';
      }

      function render(){
        var isPen = state.format==='pen';

        // fixed concentrations — neither format is reconstituted by the customer
        var totalMg = isPen ? 500 : 1000;
        var totalMl = isPen ? 3 : 5;
        var C = totalMg/totalMl; // mg/ml, fixed per format
        var volumeMl = state.dose / C;
        var dosesPerUnit = Math.floor(totalMg / state.dose); // per cartridge/vial
        var kitDoses = dosesPerUnit * 2; // every kit ships with two

        $('dc-v-dose').textContent = state.dose+' mg';
        $('dc-pen-wrap').style.display = isPen ? '' : 'none';
        $('dc-barrel-wrap').style.display = isPen ? 'none' : '';

        if(isPen){
          var penUnits = Math.round(volumeMl*100);
          $('dc-r-eyebrow').textContent='Dial the pen to';
          $('dc-r-units').textContent = fmt(volumeMl,2);
          $('dc-r-unit-label').textContent='ml';
          $('dc-r-ml').textContent = '= '+penUnits+' clicks on the dial · 1 click = '+fmt(C/100,2)+' mg';
          $('dc-r-conc').textContent = dosesPerUnit;
          $('dc-r-conc-label').textContent = 'doses per cartridge';
          $('dc-format-note-title').textContent = 'About the pen';
          $('dc-format-note-body').textContent = "Each cartridge is 3 ml of NAD+ at 500 mg, which is 300 units: one click of the dial is one unit, about 1.67 mg. Turn it until the window shows your number.";
          drawPen(penUnits);
          $('dc-r-flag').style.display='none';
        } else {
          var maxUnits=100; // a standard 1ml U-100 insulin syringe
          var units = volumeMl*100;
          var mgPerUnit = C/100;
          var over2 = units>maxUnits;
          $('dc-r-eyebrow').textContent='Draw the syringe to';
          $('dc-r-units').textContent = (units%1===0)? units : fmt(units,1);
          $('dc-r-unit-label').textContent='units';
          $('dc-r-ml').textContent = fmt(volumeMl,2)+' ml · '+fmt(mgPerUnit,1)+' mg per unit';
          $('dc-r-conc').textContent = dosesPerUnit;
          $('dc-r-conc-label').textContent = 'doses per vial';
          $('dc-format-note-title').textContent = 'About the vial';
          $('dc-format-note-body').textContent = 'Each vial is a fixed 1000mg in 5ml, ready to draw — no powder, no water to add.';
          drawBarrel(over2?maxUnits:units, maxUnits);
          var flag2=$('dc-r-flag');
          if(over2){ flag2.style.display='flex'; $('dc-r-flag-text').textContent='That dose needs '+fmt(units,0)+' units — more than a standard syringe holds. Split the dose or use a larger syringe.'; }
          else { flag2.style.display='none'; }
        }

        $('dc-r-doses').textContent = kitDoses;

        var cards = root.querySelectorAll('#dc-cards .dc-card');
        cards.forEach(function(card){
          var cf = card.dataset.format;
          card.classList.toggle('dc-is-match', cf === state.format);
        });
      }

      render();
    }
    function initAll(){ document.querySelectorAll('.tns-dc-section .dc-root').forEach(boot); }
    if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', initAll); }
    else { initAll(); }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tns-experience"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.tnsXpReady === '1') return;
      root.dataset.tnsXpReady = '1';

      var steps = root.querySelectorAll('[data-tns-xp-step]');
      var panels = root.querySelectorAll('[data-tns-xp-panel]');
      var shots = root.querySelectorAll('[data-tns-xp-shot]');
      if (!steps.length) return;

      var current = -1;

      function setActive(i) {
        if (i === current) return;
        current = i;
        [panels, shots].forEach(function (group) {
          for (var n = 0; n < group.length; n++) {
            group[n].classList.toggle('is-active', Number(group[n].dataset.tnsXpPanel || group[n].dataset.tnsXpShot) === i);
          }
        });
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) setActive(Number(entry.target.dataset.tnsXpStep));
        });
      }, { rootMargin: '-50% 0px -50% 0px', threshold: 0 });

      steps.forEach(function (step) { io.observe(step); });

      setActive(0);
    }

    function boot() {
      document.querySelectorAll('[data-tns-xp]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tns-faqs"] && !Shopify.designMode) return;
  try {
    
  /* "Talk to a human" opens the native Shopify Inbox chat widget
     (<shopify-chat>) instead of navigating away. Self-contained (doesn't
     rely on tns-assist-cta's own copy of this handler) since FAQs renders
     on pages — collection, PDP — that don't include that section. Falls
     back to the normal href if the widget hasn't loaded. */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-tns-open-chat]');
    if (!trigger) return;
    var chat = document.querySelector('shopify-chat');
    if (chat && typeof chat.show === 'function') {
      e.preventDefault();
      chat.show();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tns-hero"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var desktopMQ = window.matchMedia('(min-width:821px)');

    function initVideo(root){
      var v = root.querySelector('.tns-hero__video[data-src]');
      if (!v) return;
      function sync(){
        if (desktopMQ.matches) {
          if (!v.getAttribute('src')) {
            v.setAttribute('src', v.dataset.src);
            v.load();
          }
          var playPromise = v.play();
          if (playPromise && playPromise.catch) playPromise.catch(function(){});
        } else {
          v.pause();
        }
      }
      sync();
      if (desktopMQ.addEventListener) desktopMQ.addEventListener('change', sync);
      else if (desktopMQ.addListener) desktopMQ.addListener(sync);
    }

    document.querySelectorAll('.tns-hero-section').forEach(function(root){
      const slides = root.querySelector('.tns-slides');
      const dots = root.querySelectorAll('.tns-carousel__dot');
      const prev = root.querySelector('.tns-carousel__arrow--prev');
      const next = root.querySelector('.tns-carousel__arrow--next');
      const carousel = root.querySelector('.tns-carousel');
      if(!slides || dots.length === 0) return;
      const total = dots.length;
      const autoplay = root.dataset.autoplay === 'true';
      const interval = (parseInt(root.dataset.interval, 10) || 7) * 1000;
      let i = 0, timer;
      const go = (n) => {
        i = (n + total) % total;
        slides.style.transform = `translateX(-${i*100}%)`;
        dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
      };
      const tick = () => { if(!autoplay) return; clearInterval(timer); timer = setInterval(()=>go(i+1), interval); };
      dots.forEach(d => d.addEventListener('click', e => { go(parseInt(e.currentTarget.dataset.i,10)); tick(); }));
      if(prev) prev.addEventListener('click', () => { go(i-1); tick(); });
      if(next) next.addEventListener('click', () => { go(i+1); tick(); });
      carousel.addEventListener('mouseenter', () => clearInterval(timer));
      carousel.addEventListener('mouseleave', tick);
      tick();

      initVideo(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tns-trust-strip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function active() { return !!document.querySelector('[data-tns-cs]'); }
    function apply() {
      if (!active()) return;
      document.querySelectorAll('.buy-buttons-block').forEach(function (block) {
        if (block.classList.contains('tns-cs-hidden')) return;
        block.classList.add('tns-cs-hidden');
        var note = document.createElement('div');
        note.className = 'tns-cs';
        var label = document.createElement('span');
        label.className = 'tns-cs__label';
        label.textContent = 'Coming soon';
        var text = document.createElement('span');
        text.className = 'tns-cs__note';
        text.textContent = "This kit isn't available to order yet.";
        note.appendChild(label);
        note.appendChild(text);
        block.parentNode.insertBefore(note, block);
      });
    }
    document.addEventListener('submit', function (e) {
      if (active() && e.target.matches && e.target.matches('form[action*="/cart/add"]')) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
    else apply();
    document.addEventListener('shopify:section:load', apply);
  })();

  } catch(e) { console.error(e); }
})();
})();
